import React from "react";

const Pagenotfound = () => (
  <div className="not-found">
    <h2>Page Not Found</h2>
  </div>
);

export default Pagenotfound;
